import http from '@root/utils/axios/admin';

let state = {
    GroupCardRechargesList: [],
    GroupCardRecharge: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGroupCardRechargesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/group-recharge-cards', { params: filter }).then((response) => {
                commit('setGroupCardRecharges', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteGroupCardRecharge({ commit }, id) {
        return http.delete('/api/group-recharge-cards/' + id);
    },

    fetchGroupCardRecharge({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/group-recharge-cards/' + id).then((response) => {
                commit('setGroupCardRecharge', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateGroupCardRecharge({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/group-recharge-cards', data).then((response) => {
                commit('setGroupCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGroupCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateGroupCardRecharge({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/group-recharge-cards/' + data.id, data).then((response) => {
                commit('setGroupCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGroupCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });
    },

    receiveDelegateGroupCardRecharge({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/group-recharge-card-ready-delegate-receive', data).then((response) => {
                commit('setGroupCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGroupCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setGroupCardRecharges(state, data) {
        state.GroupCardRechargesList = data;
    },
    setGroupCardRecharge(state, data) {
        state.GroupCardRecharge.data = data;
    },
    setGroupCardRechargeError(state, error) {

        state.GroupCardRecharge.error = error.errors;
    },
    cleanGroupCardRechargeError(state, error) {
        state.GroupCardRecharge.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}